import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { L3OnboardingControllerOfPrivateKeys } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { L3OnboardingDropdown } from '../../L3OnboardingDropdown'

import type { L3OnboardingDropdownVariantProps } from '../types'
import type { SelectListItem } from '@circlefin/components/lib/SelectList'

export const controllerOfPrivateKeysSchema =
  y.mixed<L3OnboardingControllerOfPrivateKeys>()

export const ControllerOfPrivateKeys: React.FC<
  L3OnboardingDropdownVariantProps
> = (args) => {
  const { t } = useTranslation('l3Onboarding')

  const data: Array<SelectListItem<L3OnboardingControllerOfPrivateKeys>> =
    useMemo(
      () =>
        Object.values(L3OnboardingControllerOfPrivateKeys).map((option) => ({
          label: t(
            `forms.entityOperations.controllerOfPrivateKeys.options.${L3OnboardingControllerOfPrivateKeys[option]}`,
          ),
          value: L3OnboardingControllerOfPrivateKeys[option],
        })),
      [t],
    )

  return (
    <L3OnboardingDropdown
      items={data}
      label={t`forms.entityOperations.controllerOfPrivateKeys.label`}
      {...args}
    />
  )
}
